// extracted by css-extract-rspack-plugin
export default {"issueNumberText":"IssuePicker-module__issueNumberText__pmfhv"};